import { GzTagsEnumListWebComponent } from './component/GzTagsEnumListWebComponent';
import { WEB_COMPONENT_GZ_TAGS_ENUM_LIST } from '../../../webcomponents.constants';

export { GzTagsEnumListWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_TAGS_ENUM_LIST, GzTagsEnumListWebComponent);
